// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"bfc79316","113":"16252d6f","142":"7f990606","406":"0dfe5b86","438":"8ab1baeb","538":"b10b37e5","648":"f509c0be","700":"f5d53e4f","758":"af9954ab","790":"5b311e7d"}[chunkId] + ".chunk.js";
};